<script setup>
import { defineProps, ref } from 'vue';
import KSAImage from './KSAImage.vue';
import Modal from "../ui-components/modal/Modal.vue";

const { headSrc, tailSrc, title, desc, circle, frontFixedText } = defineProps(['headSrc', 'tailSrc', 'title', 'desc', 'circle', 'frontFixedText']);

const baseModal = ref(null);

const onClickPreview = () => {
    if (baseModal.value && typeof baseModal.value.open === 'function') {
        baseModal.value.open();
    }
}

const cancel = () => {
    if (baseModal.value && typeof baseModal.value.close === 'function') {
        baseModal.value.close();
    }
}

</script>

<template>
    <div class="preview-container ml-xs" v-if="headSrc || tailSrc" @click="onClickPreview">
        <div class="image-container">
            <KSAImage v-if="headSrc" :circle="circle" :src="headSrc" alt="앞면" />
            <KSAImage v-if="tailSrc" :circle="circle" :src="tailSrc" alt="뒷면" />
        </div>
        <div v-if="title" class="ml-xs">
            {{ title }} <br/>
            <p v-html="desc"></p>
        </div>
    </div>
    <Modal ref="baseModal">
        <div class="modal-inner xl-size">
            <button class="close" @click="cancel"></button>
            <div class="modal-title">
                <h3>{{ title }}</h3>
            </div>
            <div class="modal-body">
                <div class="image-container">
                    <div class="front">
                        <KSAImage v-if="headSrc" :circle="circle" :src="headSrc" alt="앞면" />
                        <p v-if="frontFixedText" v-html="frontFixedText"></p>
                    </div>
                    <div class="back">
                        <KSAImage v-if="tailSrc" :circle="circle" :src="tailSrc" alt="뒷면" />
                    </div>
                </div>
            </div>
        </div>
    </Modal>
</template>
<style lang="scss" scoped>
@import "../../assets/scss/theme.scss";

    .preview-container {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #E4E5F0;
        border-radius: 5px;
        padding: 15px;
        gap: .5rem;
        background-color: #F8F8FA;
        cursor: pointer;
        width: fit-content;
    }

    .image-container {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .5rem;
        padding: 7px;
        background-color: #fff;
    }

    .preview-container img {
        width: 125px !important;
        height: 75px !important;
    }

    .modal-title {
      min-height: 50px;
    }

    .modal-body > .image-container {
        max-height: 550px;
        div {
            position: relative;
            max-width: 50%;
            flex: 0 0 50%;
            &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 50%;
                display: block;
                width: 100%;
                height: 100%;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                z-index: 1;
                transform: translateX(-50%);
            }
            &.front {
                position: relative;
                &:after {
                    background-image: url("/src/assets/images/certificates_front_text.svg");
                }
                p {
                    position: absolute;
                    width: 85%;
                    left: 50%;
                    top: 53%;
                    z-index: 1;
                    transform: translate3d(-50%, -50%, 0) scale(0.8);
                    transform-origin: center;
                    text-align: center;
                    word-break: break-word;
                }
            }
            &.back {
              &:after {
                  background-image: url("/src/assets/images/certificates_back_text.svg");
              }
            }
        }
    }
</style>
